import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fitscovery-ui-footer',
  templateUrl: './ui-footer.component.html',
  styleUrls: ['./ui-footer.component.scss']
})
export class UiFooterComponent implements OnInit {

  constructor() { }

  pages: any[] = [];

  ngOnInit(): void {
    this.pages = [
      { title: 'toolbars.adminFooterLink', baseUrl: 'https://admin.fitscovery.com/' },
      { title: 'toolbars.aboutFooterLink', baseUrl: 'https://www.fitscovery.com/about' },
      { title: 'toolbars.termFooterLink', baseUrl: 'https://fitscovery.com/terms-and-conditions' },
      { title: 'toolbars.reportFooterLink', baseUrl: `mailto:fitscoveryplatform@gmail.com` },
    ];
  }
}
